module.exports = __webpack_public_path__ + "img/monkey-face.9eeb89a4.png";